import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { FinanceState } from "../models/FinanceState";

const setPageTransactions = (state: FinanceState, action: PayloadAction<Page>) => {
    state.finance.page = action.payload.page;
}

export default setPageTransactions;